/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>轮播列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addHandleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="sort" label="序列号" width="160">
      </el-table-column>
      <el-table-column align="center" prop="img" label="图片" width="210">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.img != null"
            :src="scope.row.img"
            style="width: 200px;height: 100px;"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.status==0?'正常':'已删除'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="150" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">排序</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 新增界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="80px" ref="editForm" :model="editForm">
        <el-form-item label="排序" prop="userName">
          <el-input size="small" v-model="editForm.bannerSort" auto-complete="off" placeholder="请输入数字（选填）"></el-input>
        </el-form-item>
        <el-upload
            class="upload-demo"
            action="https://www.neww.site:446/admin/adminimg"
            :headers="headersData"
            :on-success="handleSuccess"
            :on-error="handleError"
            :file-list="fileList"
            name="test"
            list-type="picture">
            <el-button size="small" type="primary">点击上传轮播</el-button>
          </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="轮播排序" :visible.sync="editTwoFormVisible" width="30%" @click='closeDialog("unit")'>
      <el-form label-width="80px" ref="editForm" :model="editForm">
        <el-form-item label="排序" prop="userName">
          <el-input size="small" v-model="newShowData.sort" auto-complete="off" placeholder="请输入数字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("unit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitFormUnit()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {
  userList,
  loadBanner,
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '上传轮播图',
      editFormVisible: false, //控制编辑页面显示与隐藏
      editTwoFormVisible:false,
      headersData:{
        id:localStorage.getItem('loginId'),
        hash:localStorage.getItem('logintoken')
      },
      // 编辑与添加
      editForm: {
        bannerSort: '',
        bannerUrl: '',
      },
      // 部门参数
      unitparm: {
        userIds: '',
        deptId: '',
        deptName: ''
      },
      fileList: [],
      // 选择数据
      selectdata: [],
      // 删除用户
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      // 重置密码
      resetpsd: {
        userId: '',
        token: localStorage.getItem('logintoken')
      },
      // 用户下线
      offline: {
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 10
      },
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      newShowData: []
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleSuccess(file,fileList) {
      this.fileList.name = fileList.name;
      this.fileList.url = "https://www.neww.site:446"+fileList.response.url;
      console.log(this.fileList.url)
    },
    handleError(err) {
      console.log(err)
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      userList(parameter).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.userData = res.data
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.num
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 新增
    addHandleEdit: function(index, row) {
      this.editFormVisible = true;
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.newShowData = row;
      this.editTwoFormVisible = true;
    },
    // 添加提交方法
    submitForm() {
      this.loading = true;
      loadBanner({sort:this.editForm.bannerSort,imgUrl:this.fileList.url})
        .then(res => {
          this.editFormVisible = false
          this.loading = false
          if (res.success) {
            this.getdata(this.formInline)
            this.fileList = [];
            this.$message({
              type: 'success',
              message: '数据保存成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
      })
    },
    // 排序
    submitFormUnit() {
      loadBanner({sort:this.newShowData.sort,imgId:this.newShowData.id})
        .then(res => {
          this.editTwoFormVisible = false
          this.loading = false
          if (res.success) {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '数据保存成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.editTwoFormVisible = false
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'unit') {
        this.editTwoFormVisible = false
      }
    },
    // 删除用户
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          loadBanner({imgId:row.id,del:1})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/adminSet/otherSet.vue